import { getBusinessById } from '../../../data/repositories/businessRepository.js';

export const fetchBusinessById = (id, options) => getBusinessById(id, options);
